// ECS Java script for Floating bar menu 
function ecs_FloatBar_Nav(id) {
    
    let currentElement=document.getElementById(id);
    window.sessionStorage.setItem('Nav_id',id)
   
        
    //----Highlight current selection and reset previous selection //
    if (window.sessionStorage.getItem('LastSelectedItem') ) {
      let ecsPreSelectedItem=window.sessionStorage.getItem('LastSelectedItem');
      let ecsPreSelectedElm=document.getElementById(ecsPreSelectedItem);
      if (ecsPreSelectedElm)  {
        ecsPreSelectedElm.style.backgroundColor="#1c2541";
        ecsPreSelectedElm.style.width="400px"; 
      }
    }

    currentElement.style.backgroundColor="gray";
    currentElement.style.width="400px";
    window.sessionStorage.setItem('LastSelectedItem',id)

    //------------------------- //


    //For Navigation display //
    var ecsIDFirstThree = id.substring(0,3);
    var ecsNavigation=ecsActions='';
    switch(ecsIDFirstThree) {
        case 'Mod': //Module
            ecsNavigation=currentElement.textContent
            break;
        case 'Act': //Action
            ActSplits=id.split('_')
            ModId='Mod_'+ActSplits[1];  //Get Module Id and create HTML id for module
            ModElement=document.getElementById(ModId);
            ecsNavigation=ModElement.textContent+' > '+ currentElement.textContent        
            break;
        case 'Aim': //Action item
            ActSplits=id.split('_')
            ModId='Mod_'+ActSplits[1];  //Get Module Id and create HTML id for module
            ActId='Act_'+ActSplits[1]+'_'+ActSplits[2]; //Get Action Id and create HTML id for Action
            ModElement=document.getElementById(ModId);
            ActElement=document.getElementById(ActId);
            ecsNavigation=ModElement.textContent+' > '  + ActElement.textContent +' > ' + currentElement.textContent 
            break;
    }
    
    let NavigationElement=document.getElementById('footer-content');
    NavigationElement.textContent='Navigation:'+window.sessionStorage.getItem('Module')+' > ' + ecsNavigation 
    //For Navigation display - End //
    let children = [];
    currentElement.parentElement.querySelectorAll('#ecs_Action,#ecs_ActionItem').forEach(function(ecsHtmlElement) {
      
        children.push(ecsHtmlElement);
        let el = currentElement;
        let nextEl = el.nextElementSibling;
        while (nextEl != null) {
            let collapsible = new bootstrap.Collapse(nextEl, { toggle: false });
            if (currentElement.classList.contains('show')){
                collapsible.hide(); 
            } else {
                collapsible.show();
            }
            nextEl = nextEl.nextElementSibling;
        }
    });
    currentElement.classList.toggle('show'); 
    //alert(document.cookie)   
}
//-----------------------------------------------------------//
